import React, { Component } from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";
import { selectLanguageConvert, showErrorMessage } from "services/utility";
import analytics from "services/firebaseServices/firebaseAnalytics";
import { withTranslation } from "react-i18next";

export class SelectLanguage extends Component {
  constructor(props) {
    super(props);

    analytics.logEvent("language_screen_launched_in_onboarding", {
      languageScreen: true,
    });
  }
  state = {
    selectedLanguage: "",
    spinnerForFeed: this.props.spinnerForFeed,
  };
  // componentWillReceiveProps() {
  //   this.setState({ spinnerForFeed: this.props.spinnerForFeed });
  // }

  spinnerState() {
    this.setState({ spinnerForFeed: true });
  }

  onProceed() {
    if (this.state.selectedLanguage.length > 0) {
      this.spinnerState();
      this.props.selectedlanguage(this.state.selectedLanguage);
    } else {
      showErrorMessage("Please select Language", 1);
    }
  }

  render() {
    let selectedLanguageState = async (value) => {
      await this.setState({ selectedLanguage: value });
      analytics.logEvent("language_selected_in_onboarding", {
        selectedLanguage: value,
      });
    };
    // let isDisable = !(this.state.selectedLanguage.length > 0);

    return (
      <div id="content" >
        <div className="row no-gutters" id="bottom-card">
          <div className="col-md-12 no-gutters">
            <div className="col-sm-8 mx-auto text-center my-auto onboarding-language">
              {/* <img src="images/select-School.png" width="300"
              height="auto" className="img-fluid" /> */}
            </div>
            <div className="col-sm-8  mx-auto  my-auto loginCard ">
              <div className="row no-gutters my-auto">
                <div className="cardtitle text-white text-center">Select Language</div>
              </div>
              <div className="row my-2 ">
                <div className="col-sm-10 mx-auto">
                  <div className="form-group ">
                    <div className="row  mb-3 d-flex justify-content-center">
                      {window.languageList.map((element, i) => {
                        return (
                          <div
                            className="language-item-flex"
                            onClick={(e) => {
                              selectedLanguageState(element);
                            }}
                          >
                            <input
                              type="radio"
                              name="radio1"
                              id={element}
                              defaultValue={element}
                              //   defaultChecked
                            />
                            <label className=" select-label" htmlFor={element}>
                              {selectLanguageConvert(element)}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {!this.props.spinnerForFeed && (
                    <div className="form-group">
                      <button
                        type="button"
                        className="card-button"
                        // disabled={isDisable}
                        onClick={(e) => {
                          // this.props.hidefunction();
                          this.onProceed();
                        }}
                      >
                        Proceed
                      </button>
                    </div>
                  )}
                  {this.props.spinnerForFeed && (
                    <div className="text-center">
                      <Spinner
                        className=" "
                        animation="border"
                        style={{ color: "#1b1f5f" }}
                        size="lg"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SelectLanguage);
